const BIG_WINNER_POD_CONTAINER_CLASS = 'w-38.75 h-16 flex-shrink-0 rounded-sm';

export { BIG_WINNER_POD_CONTAINER_CLASS };
